module.exports = __webpack_public_path__ + "media/bàep née rîak wâa chon chìng dtee-chìng.1d077a5c.mp3";